import { render, staticRenderFns } from "./Component-Communicationresources.vue?vue&type=template&id=4f1ca5a4&"
import script from "./Component-Communicationresources.vue?vue&type=script&lang=js&"
export * from "./Component-Communicationresources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports